/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Lv_Open_DocsInputs */

const cs_property_registry_lv_open_docs = /** @type {(inputs: Property_Registry_Lv_Open_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít dokumenty`)
};

const en_property_registry_lv_open_docs = /** @type {(inputs: Property_Registry_Lv_Open_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open documents`)
};

/**
* | output |
* | --- |
* | "Open documents" |
*
* @param {Property_Registry_Lv_Open_DocsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_lv_open_docs = /** @type {((inputs?: Property_Registry_Lv_Open_DocsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Lv_Open_DocsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_lv_open_docs(inputs)
	return cs_property_registry_lv_open_docs(inputs)
});